export const UTM_SOURCES = [
  { label: "Facebook", value: "facebook" },
  { label: "Google", value: "google" },
  { label: "Instagram", value: "instagram" },
  { label: "Email", value: "email" },
  { label: "Newsletter", value: "newsletter" },
  { label: "YouTube", value: "youtube" },
  { label: "LinkedIn", value: "linkedin" },
  { label: "TikTok", value: "tiktok" },
  { label: "Anders", value: "other" },
];

export const UTM_MEDIUMS = [
  { label: "Social Media", value: "social" },
  { label: "Cost Per Click (CPC)", value: "cpc" },
  { label: "Email Marketing", value: "email" },
  { label: "Display Advertising", value: "display" },
  { label: "Referral", value: "referral" },
  { label: "Organic Search", value: "organic" },
  { label: "Affiliate", value: "affiliate" },
  { label: "Direct", value: "direct" },
  { label: "Anders", value: "other" },
];
